/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query MyQuery($companyName: String!) {
    VideoLogsCount(companyName: $companyName) {
      VideoLogsCount
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
